export const DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT = 'recipient'

export const DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_BUILDING = 'building'

export const DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_BUILDING_GROUP =
  'building_group'

export const DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_FLAT = 'flat'
